import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ExtendBox from './ExtendBox';

const Wrapper = styled.div`
  padding: 0 25px;
  margin: 40px 0;
`;

function ExtendWarranty({
  extendPlanSelected,
  setExtendPlanSelected,
  productData
}) {
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [cheapestPlan, setCheapestPlan] = useState(null);
  const productId = productData.id;

  useEffect(() => {
    setCheapestPlan(null);
    const fetchData = async () => {
      try {
        setLoadingPlans(true);
        const response = await fetch(
          `${window.extendHost}/offers?storeId=${
            window.extendStoreId
          }&productId=${productId}&region=US`,
          {
            headers: {
              Accept: 'application/json; version=2021-04-01'
              // 'Content-Type': 'application/x-www-form-urlencoded',
            }
          }
        );

        const extendData = await response.json();

        if (extendData?.plans?.adh?.length > 0) {
          const min = extendData.plans.adh.reduce(function(prev, current) {
            return prev.price < current.price ? prev : current;
          });

          // /** initialize offer */
          // Extend.buttons.render('#extend-offer', {
          //   referenceId: productId
          // });

          setCheapestPlan(min);
        } else {
          setCheapestPlan(null);
        }
      } catch (err) {
        console.log('error', err);
      }

      setLoadingPlans(false);
    };
    fetchData();
  }, [productId]);

  const handleClick = event => {
    event.preventDefault();

    /** get the component instance rendered previously */
    // Extend.buttons.instance('#extend-offer');

    window.Extend.modal.open({
      referenceId: productId,
      onClose: function(plan, product) {
        if (plan && product) {
          setExtendPlanSelected(plan);
        } else {
          setExtendPlanSelected(null);
        }
      }
    });
  };

  return (
    <Wrapper>
      {!loadingPlans && cheapestPlan && window?.Extend && (
        <ExtendBox
          cheapestPlan={cheapestPlan}
          extendPlanSelected={extendPlanSelected}
          handleClick={handleClick}
          removePlan={() => setExtendPlanSelected(null)}
        />
      )}

      <div id="extend-offer" />
    </Wrapper>
  );
}

export default ExtendWarranty;
